import React, { useEffect, useRef } from "react";
import { graphql } from "gatsby";
import parse from "html-react-parser";
import { gsap } from "gsap";
import StructuredText from "../custom-structured-text-renderer";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";
import marqueeEffect from "../../../hooks/marquee-effect";

const CampaignTitleGalleryContent = ({ title, gallery, richContent }) => {
  const sliderRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Auto-scroll marquee is mobile-only (the desktop grid is shown instead).
    if (!window.matchMedia("(max-width: 900px)").matches) return;

    const wrappers = sliderRef.current?.querySelectorAll(
      ".campaign-title-gallery-content__slider-wrapper"
    );
    if (!wrappers?.length) return;

    const tl = marqueeEffect(gsap.utils.toArray(wrappers), {
      paused: false,
      repeat: -1,
      speed: 0.5,
    });

    return () => tl && tl.kill();
  }, []);

  return (
    <section className="campaign-title-gallery-content">
      <div className="campaign-title-gallery-content__inner">
        {title && (
          <div className="campaign-title-gallery-content__title" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            <h2>{parse(title)}</h2>
          </div>
        )}

        {gallery?.length > 0 && (
          <div className="campaign-title-gallery-content__gallery">
            {gallery.map((asset, i) => (
              <div key={i} className="campaign-title-gallery-content__gallery-item" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                <Asset asset={asset} />
              </div>
            ))}
          </div>
        )}

        {gallery?.length > 0 && (
          <div className="campaign-title-gallery-content__slider" ref={sliderRef} aria-hidden="true">
            {[0, 1, 2].map((dup) => (
              <div className="campaign-title-gallery-content__slider-wrapper" key={dup}>
                {gallery.map((asset, i) => (
                  <div className="campaign-title-gallery-content__slider-item" key={i}>
                    <Asset asset={asset} />
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        {richContent && (
          <div className="campaign-title-gallery-content__content" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            <StructuredText data={richContent} />
          </div>
        )}
      </div>
    </section>
  )
}

export default CampaignTitleGalleryContent

export const query = graphql`
  fragment CampaignTitleGalleryContentProps on DatoCmsCampaignTitleGalleryContent {
    ... on DatoCmsCampaignTitleGalleryContent {
      id
      title
      gallery {
        ...InternalAssetProps
      }
      richContent {
        value
      }
    }
  }
`
